import React, { useContext } from "react";
import { Box, Typography, Paper, Container } from "@mui/material";
import { AuthContext } from "../../context/AuthContext";
import { Navigate } from "react-router-dom";
import UserProfileTabs from "./components/UserProfileTabs";
import { muiTheme } from "../../global/styles/muiTheme";

/**
 * Admin page for managing layer permissions
 * Only accessible to users with admin role
 */
export default function AdminLayers() {
  const { isAdmin, user } = useContext(AuthContext);

  // Redirect non-admin users
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return (
    <Box sx={{ backgroundColor: "#FFFFFF", minHeight: "100vh", pt: 16, pb: 4 }}>
      <Container maxWidth="lg">
        <Typography variant="h1" gutterBottom paddingTop={muiTheme.spacing(10)}>
          Gerenciamento
        </Typography>
        <UserProfileTabs user={user} />
      </Container>
    </Box>
  );
}
